import { render, staticRenderFns } from "./bloquearCliente.vue?vue&type=template&id=2a70ead5&"
import script from "./bloquearCliente.vue?vue&type=script&lang=js&"
export * from "./bloquearCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports